import Drawable from '../entities/Drawable.js';

import { spriteStore } from '../images.js';

export default class StatusBadge extends Drawable {
    constructor({ status, position = { x: 0, y: 0 }, visible = true }) {
        super();
        this.status = status;
        this.position = position;
        this.visible = visible;
        this.sprites = {};
        this.sprites.sb = spriteStore.store.statusBadge;
    }

    draw() {
        if (!this.visible) {
            return;
        }

        this.sprites.sb.frames.val = {
            poison: 0,
            bad_poison: 0,
            paralysis: 1,
            sleep: 2,
            freeze: 3,
            burn: 4,
            pokerus: 5,
            faint: 6,
            blank: 7,
        }[this.status];
        this.sprites.sb.position.x = this.position.x;
        this.sprites.sb.position.y = this.position.y;
        this.sprites.sb.draw();
    }
}
